import type { LandingPageContent } from '../types'

export const ZLOZYC_ZAPYTANIE_FOTOWOLTAICZNE: LandingPageContent = {
  slug: 'zlozyc-zapytanie-fotowoltaiczne',
  lang: 'pl',
  topicId: 'photovoltaik-anfrage-erstellen',
  title: 'Złóż zapytanie fotowoltaiczne – w kilka minut',
  metaDescription:
    'Złóż w kilka minut anonimowe zapytanie o instalację fotowoltaiczną: prześlij zdjęcia dachu, ' +
    'firmy składają oferty, Ty decydujesz.',
  keywords: [
    'złóż zapytanie fotowoltaiczne',
    'zapytanie o instalację fotowoltaiczną',
    'poproś o ofertę fotowoltaiczną',
    'wniosek instalacja PV',
  ],
  eyebrow: 'Gotowe w kilka minut',
  h1: 'Złóż swoje zapytanie fotowoltaiczne w kilka minut',
  intro:
    'Zamiast wypełniać formularze u kilku dostawców osobno, w Roofora składasz jedno anonimowe ' +
    'zapytanie - a kilka firm rzemieślniczych składa na nie oferty. Zobacz, czego do tego potrzebujesz ' +
    'i co dzieje się dalej.',
  sections: [
    { type: 'heading', text: 'Czego potrzebujesz do swojego zapytania' },
    {
      type: 'list',
      items: [
        'Kilka zdjęć dachu (wystarczą zdjęcia z telefonu)',
        'Zdjęcie Twojej rozdzielnicy',
        'Orientacja i kąt nachylenia dachu, jeśli je znasz',
        'Twoje przybliżone roczne zużycie energii, opcjonalnie z pompą ciepła lub samochodem elektrycznym',
      ],
    },
    { type: 'heading', text: 'Tak Roofora oblicza odpowiednią wielkość Twojej instalacji' },
    {
      type: 'paragraph',
      text:
        'Na podstawie Twoich danych system automatycznie wyznacza odpowiednią konfigurację instalacji ' +
        '- wielkość i moc, dopasowane do Twojego dachu i zużycia. Nie potrzebujesz przy tym żadnej ' +
        'wiedzy technicznej.',
    },
    { type: 'heading', text: 'Co dzieje się po złożeniu zapytania' },
    {
      type: 'paragraph',
      text:
        'Twoje zapytanie zostaje opublikowane anonimowo - firmy rzemieślnicze w Twoim regionie widzą ' +
        'dane dachu i zużycie, ale nie Twoje dane kontaktowe. Mają 2-4 tygodnie na złożenie niewiążących ' +
        'ofert, które pojawiają się u Ciebie posortowane według ceny.',
    },
    { type: 'heading', text: 'Twoje dane pozostają chronione, dopóki się nie zgodzisz' },
    {
      type: 'paragraph',
      text:
        'Dopiero gdy indywidualnie zaakceptujesz konkretną firmę rzemieślniczą, udostępniane są e-mail ' +
        'i numer telefonu - bez zbiorowej zgody dla wszystkich zainteresowanych. Do konta potrzebujesz ' +
        'tylko nazwy użytkownika i hasła, bez adresu e-mail.',
    },
  ],
  primaryCta: { label: 'Złóż zapytanie bezpłatnie już teraz', action: 'customer' },
  secondaryCta: { label: 'Zobacz najpierw szacunkowe koszty', action: 'link', href: '/koszt-instalacji-fotowoltaicznej' },
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Zaplanuj instalację krok po kroku', href: '/zaplanuj-instalacje-fotowoltaiczna' },
  ],
}
